import { createClient } from "contentful";

const client = createClient({
  space: "6vx0vysvs1ug",
  accessToken: "7Q6poAiL1gfl-31E4p_KRZXFSB4TdZ_jInbtUWcfNtY",
});

export default client;
